import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import TransferOrderDispatch from 'Store/Transfer/Transfer/TransferOrderByIdDispatch'
import AssetOrderDetailView from './AssetOrderDetailView'
import { useNavigate, useParams } from 'react-router-dom';
import permissions, { isAuthorized } from 'client/utils/Permissions';
import { CONSTANTS } from 'client/utils/constants';
import TransferAction from 'Store/Component/Transfer/TransferAction';

const AssetOrderDetailViewContainer = (props: any) => {
  const {tab, setSelectedKey, tabSwitchClicked, setTabSwitchClicked} = props
  const [mobile, setMobile] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getTransferOrderDetailById = TransferOrderDispatch.dispatchGetTransferOrderById(dispatch);

  const { transferOrderByIdData,  getUserDetails, afeOrderByIdData}: any = useSelector((state: any) => ({
    transferOrderByIdData: state.TransferOrderReducer.transferOrderByIdData,
    getUserDetails: state.UserProfile.getUserDetails,
    afeOrderByIdData: state.TransferReducer.afeOrderByIdData
  }));

  let { id, requesttype } = useParams();

  useEffect(() => {
    if (id != undefined && getUserDetails?.permissions?.length > 0) {
      if(isAuthorized(permissions.ApprovalsView)){
        if(requesttype === CONSTANTS.AFEREQUEST){
          dispatch(TransferAction.getAfeOrderById(id));
        }else{
        getTransferOrderDetailById(id);
        }
      }else{
        navigate('/ordermanagement/blank');
      } 
    }
  }, [id, getUserDetails?.permissions])

  useEffect(() => {
    if (tabSwitchClicked) {
      setSelectedKey(tab)
      setTabSwitchClicked(false)
    }
  }, [tabSwitchClicked])

  useEffect(() => {
    const resizeFun = () => {
      if (window.innerWidth < 600) {
        setMobile(true)
      }
      else {
        setMobile(false);
      }
    }
    resizeFun();
    window.addEventListener('resize', resizeFun)
    return () => window.removeEventListener('resize', resizeFun)
  }, []);

  return (
    <AssetOrderDetailView
      orderDetails={transferOrderByIdData}
      mobile={mobile}
      ordertype = {requesttype}
      afeOrderByIdData={afeOrderByIdData}
    />
  )
}

export default AssetOrderDetailViewContainer